import { render, staticRenderFns } from "./BoPagination.vue?vue&type=template&id=5f9187b5&"
import script from "./BoPagination.vue?vue&type=script&lang=js&"
export * from "./BoPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports